import { createElement } from 'react';
import { bD as __rest, bE as __assign } from './index.esm-47de5464.js';
import 'react-measure';
import 'react-router-dom';
import 'react-dom';
import 'throttle-debounce';
import 'focus-trap-react';
import 'react-swipeable';
import 'react-animate-height';
import 'country-flag-emoji-polyfill';
import 'intersection-observer';
import 'html-react-parser';

var SvgComponent = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M16.151 15.3031C17.225 14.0131 17.871 12.3561 17.871 10.5501C17.871 6.44806 14.534 3.11206 10.432 3.11206C6.33002 3.11206 2.99402 6.44806 2.99402 10.5501C2.99402 14.6521 6.33102 17.9881 10.433 17.9881C12.298 17.9881 14.005 17.2991 15.312 16.1601L19.977 20.8251L20.826 19.9771L16.152 15.3021L16.151 15.3031ZM10.432 16.7891C6.99202 16.7891 4.19302 13.9901 4.19302 10.5501C4.19302 7.11006 6.99202 4.31106 10.432 4.31106C13.872 4.31106 16.671 7.11006 16.671 10.5501C16.671 13.9901 13.872 16.7891 10.432 16.7891Z"
  }));
};

export default SvgComponent;
